import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DrillingOperations.css';

const DrillingOperations = () => {
    const [activeFaq, setActiveFaq] = useState(0);
    const navigate = useNavigate();
    const goToContact = () => navigate('/contact', { state: { scrollToForm: true } });

    const faqs = [
        {
            q: "What hole diameters can you drill?",
            a: "We handle a wide range of diameters depending on material and component design."
        },
        {
            q: "Do you provide deep hole drilling?",
            a: "Yes, we offer deep hole drilling based on drawing requirements."
        },
        {
            q: "Can you handle bulk drilling production?",
            a: "Yes, we support both small batch and high-volume production runs."
        }
    ];

    return (
        <div className="drilling-machining-page">
            {/* Hero Section */}
            <section className="drilling-hero">
                <div className="container">
                    <h1 className="fade-in">Precision Drilling Operations Services</h1>
                </div>
            </section>

            {/* About Section */}
            <section className="drilling-about-section section-padding">
                <div className="container">

                    <div className="drilling-about-header">
                        <div className="drilling-about-title-group">
                            <div className="drilling-icon-wrapper">
                                <img src="https://sakthivel.ascentbw.com/Files/About/About3.png" alt="Drilling Icon" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/About/About1.png"; }} />
                            </div>
                            <h2>About Our Drilling Operations</h2>
                        </div>

                        <div className="drilling-about-header-split">
                            <div className="drilling-about-header-text">
                                <p>Sakthivel Engineering provides precision drilling services for a wide range of industrial metal components. Our advanced drilling machines ensure accurate hole positioning, consistent depth control, and superior finish across both prototype and production volumes.</p>
                            </div>
                            <div className="drilling-about-header-btn">
                                <button className="btn-primary" onClick={goToContact}>Request a Quote</button>
                            </div>
                        </div>
                    </div>

                    <div className="drilling-capabilities-group">
                        <div className="drilling-capability-block">
                            <h3>Our Drilling Capabilities</h3>
                            <p>We offer high-precision drilling solutions designed to meet exact engineering specifications and production requirements.</p>
                            <p className="mt-20">Our capabilities include:</p>
                            <ul className="drilling-capabilities-list mt-10">
                                <li>• High-Precision Hole Drilling</li>
                                <li>• Deep Hole Drilling</li>
                                <li>• Tapping & Thread Drilling</li>
                                <li>• Reaming Operations</li>
                                <li>• Counterboring & Countersinking</li>
                                <li>• Batch Production Drilling</li>
                            </ul>
                        </div>

                        <div className="drilling-capability-block mt-40">
                            <h3>Our Drilling Services Include</h3>
                            <p>We deliver reliable and accurate drilling operations tailored to your component drawings and tolerance requirements.</p>
                        </div>
                    </div>

                    <div className="drilling-about-img mt-40">
                        <img src="https://sakthivel.ascentbw.com/Files/Service/Sub3.png" alt="Drilling Process" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/Service/Sub1.png"; }} />
                    </div>

                    <div className="drilling-quality-block mt-40">
                        <h3>Quality & Process Control</h3>
                        <p className="mt-20">At Sakthivel Engineering, every drilled component undergoes strict quality inspection to ensure dimensional accuracy and hole alignment.</p>
                        <ul className="drilling-quality-list mt-20">
                            <li>Precision depth verification</li>
                            <li>Diameter measurement checks</li>
                            <li>Surface finish inspection</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Process Section */}
            <section className="drilling-process-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-50">Our Drilling Process</h2>

                    <div className="process-grid">
                        <div className="process-card">
                            <div className="process-num">01</div>
                            <h5 className="process-accent">Requirement Review</h5>
                            <h4>Requirement Analysis &<br />Planning</h4>
                            <p>We evaluate technical drawings, hole specifications, tolerances, and material type before machining begins.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">02</div>
                            <h5 className="process-accent">Machining Process</h5>
                            <h4>Precision Drilling<br />Execution</h4>
                            <p>Using calibrated drilling machines, we perform accurate hole creation with proper feed rates and speed control to ensure clean finishing.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">03</div>
                            <h5 className="process-accent">Quality & Delivery</h5>
                            <h4>Inspection &<br />Delivery</h4>
                            <p>Each component is inspected for dimensional accuracy before safe packaging and timely dispatch.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ & Split Section */}
            <section className="drilling-faq-section section-padding bg-light pt-0">
                <div className="container">
                    <div className="drilling-faq-split">

                        <div className="drilling-faq-left">
                            <h5 className="faq-accent">FAQ</h5>
                            <h2 className="section-title text-left">Frequently Asked<br />Questions</h2>
                            <p>Find answers to common questions about our drilling services, capabilities, and production process.</p>
                            <button className="btn-primary mt-30" onClick={goToContact}>Request a Quote</button>
                        </div>

                        <div className="drilling-faq-right">
                            <div className="drilling-faq-grid">
                                {faqs.map((faq, idx) => (
                                    <div
                                        key={idx}
                                        className={`drilling-faq-item ${activeFaq === idx ? 'active' : ''}`}
                                        onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                                    >
                                        <div className="drilling-faq-header">
                                            <h4>{faq.q}</h4>
                                            <span className="toggle-icon1"></span>
                                        </div>
                                        <div className="drilling-faq-body">
                                            <p>{faq.a}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="drilling-cta-section">
                <div className="container text-center">
                    <h2>Need Reliable Drilling<br />Operations?</h2>
                    <p>Share your technical drawings and drilling specifications with us. Our team will provide an<br />accurate quotation and production timeline.</p>
                    <button className="btn-light mt-30" onClick={goToContact}>Request a Drilling Quote</button>
                </div>
            </section>
        </div>
    );
};

export default DrillingOperations;
